import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'pagination',
  imports: [CommonModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  totalPages = input(0);
  currentPage = input(0);
  updateUrlOnChange = input(true);
  changePage = output<number>();

  get page(): number {
    return this.currentPage();
  }

  get total(): number {
    return this.totalPages();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.total) return;

    this.changePage.emit(page);

    if (this.updateUrlOnChange()) {
      this.router.navigate([], {
        queryParams: { page },
        queryParamsHandling: 'merge',
        replaceUrl: true,
        relativeTo: this.activatedRoute,
      });
    }
  }
}
